import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  // Bearer-token based auth; no cookies needed across origins.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
